<template>
    <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <!-- eslint-disable vue/max-attributes-per-line max-len -->
        <path d="M60.166 17.7828H7.9134C5.75209 17.7828 4 19.4918 4 21.5999V52.183C4 54.291 5.75209 56 7.9134 56H60.166c2.1613 0 3.9134-1.709 3.9134-3.817V21.5999c0-2.1081-1.7521-3.8171-3.9134-3.8171Z" fill="#000" shape-rendering="crispEdges"/>
        <path d="M62.7685 18.7324 34.0349 41.6627 5.30127 18.7324" fill="#000" shape-rendering="crispEdges"/>
        <path d="M65.6024 16.3632c.7229.6769 1.1566 1.6453 1.1566 2.6983v30.5737c0 1.053-.453 2.0401-1.1759 2.6982-.694.7051-1.6579 1.1282-2.7375 1.1282H10.6027c-1.07959 0-2.04348-.4231-2.73748-1.1282-.72292-.6581-1.17595-1.6452-1.17595-2.6982V19.0521c0-1.053.43375-2.012 1.15667-2.6983.694-.7051 1.68681-1.1282 2.76636-1.1282h52.2333c1.0796 0 2.0628.4231 2.7664 1.1282l-.0096.0094Z" fill="#fff" stroke="#000" stroke-width=".3" stroke-linecap="round" stroke-linejoin="round" shape-rendering="crispEdges"/>
        <path d="M65.4578 16.5231 45.4088 32.515l-8.6943 6.9383-8.6846-6.9195-20.049-16.0107M7.9809 52.183l19.5959-19.1039M65.4578 52.183 45.8715 33.0791" stroke="#000" stroke-width=".3" stroke-linecap="round" stroke-linejoin="round" shape-rendering="crispEdges"/>
        <!-- eslint-enable -->
    </svg>
</template>
